import React, { useState, useRef, useEffect } from "react"
import PropTypes from "prop-types"
import _includes from "lodash/includes"
import _without from "lodash/without"
import _concat from "lodash/concat"
import classNames from "classnames"

import calendarIcon from "assets/svg/calendar.svg"
import arrowDownIcon from "assets/svg/arrow-down.svg"
import checkIcon from "assets/svg/check.svg"

import styles from "./styles.css"

const SelectPeriod = ({ onChange, months }) => {
  const rootRef = useRef(null)
  const [selected, setSelected] = useState([])
  const [isOpen, setIsOpen] = useState(false)
  const showEmptySelect = selected.length === 0

  const isSelectedMonth = (month) => _includes(selected, month)

  const handleClose = () => setIsOpen(false)

  const handleToggleOpen = () => {
    setIsOpen(!isOpen)
  }

  const handleSelect = (month) => {
    let months = []
    if (isSelectedMonth(month)) {
      months = _without(selected, month)
    } else {
      months = _concat(selected, month)
    }

    setSelected(months)
    onChange(months)
    handleClose()
  }

  const handleRemove = (month) => {
    const newMonths = _without(selected, month)
    setSelected(newMonths)
    onChange(newMonths)
  }

  const initClickOutsite = () => {
    const handleClickOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        handleClose()
      }
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        handleClose()
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    document.addEventListener("keydown", handleKeyDown)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
      document.removeEventListener("keydown", handleKeyDown)
    }
  }

  useEffect(initClickOutsite, [])

  return (
    <div ref={rootRef} className={styles.root}>
      <div className={styles.container} onClick={handleToggleOpen}>
        <img src={calendarIcon} />
        {showEmptySelect ? (
          <p>Escolha o período</p>
        ) : (
          <div className={styles.badgeContainer}>
            {selected.map((month) => (
              <span key={month} className={styles.badge}>
                {month}
                <button
                  type="button"
                  className={styles.removeBtn}
                  onClick={(e) => {
                    e.stopPropagation()
                    handleRemove(month)
                  }}
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        )}
        <img src={arrowDownIcon} className={styles.arrow} />
      </div>

      <ul
        className={classNames(styles.menu, {
          [styles.menuOpen]: isOpen
        })}
      >
        {months.map((month) => (
          <li
            key={month}
            className={classNames(styles.item, {
              [styles.itemSelected]: isSelectedMonth(month)
            })}
            onClick={() => handleSelect(month)}
          >
            {isSelectedMonth(month) && (
              <img className={styles.checkIcon} src={checkIcon} />
            )}
            {month}
          </li>
        ))}
      </ul>
    </div>
  )
}

SelectPeriod.defaultProps = {
  months: [],
  onChange: () => {}
}

SelectPeriod.propTypes = {
  months: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func
}

export default SelectPeriod



// WEBPACK FOOTER //
// ./src/scenes/ConsumptionProfile/components/SelectPeriod/index.js